import { FileWarning } from 'lucide-react';
import type { ReactElement } from 'react';

import { StatePanel } from '@/components/ui/StatePanel';
import { errorAdvice } from '@/lib/error-advice';

/** No se pudieron leer los permisos del usuario (`/me` falló): no es "sin acceso". */
export function PermissionErrorPanel({
  error,
  onRetry,
  retrying = false,
}: {
  /** La falla de `/me`: decide qué se le aconseja al usuario. */
  error: unknown;
  onRetry: () => void;
  retrying?: boolean;
}): ReactElement {
  return (
    <StatePanel
      icon={<FileWarning />}
      title="No se pudieron verificar tus permisos"
      tone="danger"
      role="alert"
      onRetry={onRetry}
      retrying={retrying}
    >
      {errorAdvice(error)}
    </StatePanel>
  );
}
